var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7005_3196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5Z",
    stroke: "#8A8B91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.129 12.8819C8.04525 12.8819 7.96087 12.8819 7.879 12.8819L5.87587 14C5.09607 13.7377 4.37279 13.3306 3.744 12.8L3.7365 10.55C3.69212 10.48 3.65025 10.4094 3.6115 10.3369L1.61962 9.2025C1.46273 8.40893 1.46273 7.59232 1.61962 6.79875L3.60962 5.6675C3.65025 5.59563 3.69212 5.52437 3.73462 5.45437L3.74462 3.20438C4.37285 2.67228 5.09595 2.26365 5.87587 2L7.87587 3.11812C7.95962 3.11812 8.044 3.11812 8.12587 3.11812L10.1259 2C10.9057 2.2623 11.629 2.66943 12.2577 3.2L12.2652 5.45C12.3096 5.52 12.3515 5.59063 12.3902 5.66313L14.3809 6.79688C14.5378 7.59044 14.5378 8.40706 14.3809 9.20063L12.3909 10.3319C12.3502 10.4037 12.3084 10.475 12.2659 10.545L12.2559 12.795C11.6281 13.3272 10.9054 13.736 10.1259 14L8.129 12.8819Z",
    stroke: "#8A8B91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7005_3196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.0df9df975722d27ad5d37bd5f183034f.svg";
export { ForwardRef as ReactComponent };